import { formatDateTime } from '@bussola-viagens/utils'
import { CreateGroupDocumentSchema } from '@bussola-viagens/validations'
import { GridActionsCellItem, GridAddIcon, GridDeleteIcon, GridRowParams, GridSlots, GridToolbarContainer } from '@mui/x-data-grid'
import { useFormik } from 'formik'
import { enqueueSnackbar } from 'notistack'
import {Fragment, useEffect} from 'react'
import { Button, FileUploader, Grid, Input, Loader, LoaderContainer, Modal, Paper, Table } from "../../../../components"
import { useAPI, useToggle } from "../../../../hooks"
import DownloadIcon from '@mui/icons-material/Download';
import { group, group_training } from '@bussola-viagens/database'
import CheckIcon from '@mui/icons-material/Check';
import { useNavigate } from 'react-router-dom'

interface TrainingsProps {
    groupId: string
}

export const Trainings = ({groupId}: TrainingsProps) => {
    const navigate = useNavigate()
    const [group, refetchGroup] = useAPI(`/group/${groupId}`)
    const [trainings] = useAPI(`/training`)
    const [updatedGroup, updateGroup] = useAPI({}, { manual: true })

    const form = useFormik({
        initialValues: {
            trainings: '',
        },
        onSubmit: async (value, helper) => {
            const {status} = await updateGroup({
                url: `/group/${groupId}/training`,
                method: 'PUT',
                data: value
            })

            if (status <= 299) {
                enqueueSnackbar('Grupo atualizado com sucesso!', {variant: 'success'})
                await refetchGroup()
                helper.setStatus('draft')
            }
        },
        initialStatus: 'draft'
    })

    useEffect(() => {
        if (group.data && form.status === 'draft') {
            form.resetForm({
                values: {
                    trainings: group.data.group_training.map((item: group_training) => item.training_id)
                },
                status: 'initiated'
            })
        }
    }, [form, form.status, group])

    if (group.loading || trainings.loading || form.status === 'draft' || updatedGroup.loading) {
        return (
            <LoaderContainer>
                <Loader />
            </LoaderContainer>
        )
    }

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Paper>
                    <Table 
                        rowSelection={true}
                        checkboxSelection
                        onRowSelectionModelChange={(value) => {
                            form.setFieldValue('trainings', value)
                        }}               
                        rowSelectionModel={form.values.trainings}   
                        columns={[
                            { field: 'created_at', flex: 1, type: 'dateTime', headerName: 'Data de Criação', valueGetter: (value) => new Date(value), valueFormatter: formatDateTime },
                            { field: 'name', flex: 1, type: 'string', headerName: 'Nome' },
                            { field: 'lessons', flex: 1, type: 'number', headerName: 'Aulas', valueGetter: (value: Array<string>) => value.length },
                        ]}
                        rows={trainings.data || []}
                        slots={form.dirty ? {
                            toolbar: () => {
                                return (
                                    <GridToolbarContainer>
                                        <Button variant='text' startIcon={<CheckIcon />} onClick={() => form.handleSubmit()}>
                                        Salvar
                                        </Button>
                                    </GridToolbarContainer>
                                )
                            }
                          } : undefined}                  
                    />
                </Paper>
            </Grid>
        </Grid> 
    )
}
  